<template>
	<div id="legal">
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div class="inner" v-html="termsOfSale"></div>
	</div>
</template>

<script>
export default {
	name: 'TermsOfUse',
	data() {
		return {
			termsOfSale: '',
		};
	},
	created() {
		this.$http.get(`${this.cdnHost}/frontend/v2/${environment.region}/terms-of-sale/${this.localeCode}.json`).then((response) => {
			this.termsOfSale = response.data;
		});
	},
};
</script>
